var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSelectTool = function SvgSelectTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.19 2.607H4.983l-2.6 4.491 2.6 4.491H8.31l.352 1.198h-4.37L1 7.098 4.293 1.41h6.587l3.293 5.688-.682 1.178-1.17-.37.468-.808-2.6-4.49zm4.64 10.512l-1.179 1.179-2.771-2.77-1.07 2.94-2.223-7.413L15 9.28l-2.941 1.069 2.77 2.77z",
    fill: "#666"
  })));
};
export default SvgSelectTool;